import { isDebug } from "@base/BuildEnvironment";
import { Util } from "@base/util/Util";
import { Access, AccessFeature, AccessFeatures, DealerType, UserType } from "@biz/definitions/AccessDefinitions";
import { AccessHelper } from "@biz/logic/AccessHelper";
import { IUserContactData } from "@biz/userProjects/new/IProjectDefinitions";

import type { IBeosCompany, IBeosUser } from "@biz/definitions/DatabaseDefinitions";
import type { IResponsibilityFilter } from "@biz/responsibilityArea/ResponsibilityAreaDefinitions";
export class DeviceItem {
  public type: string = "T";
  public id: string = "";
  public lastAccess: number = 0;
}
// interface _JwtPayload {
//   iss?: string | undefined;
//   sub?: string | undefined;
//   aud?: string | string[] | undefined;
//   exp?: number | undefined;
//   nbf?: number | undefined;
//   iat?: number | undefined;
//   jti?: string | undefined;
// }

export interface IResfreshTokenData {
  _id: string;
  userName: string;
  type: string;
}

export interface IAppUserDealer {
  dealerType?: DealerType;
  responsibilityFilterId?: string;
  companyId?: number;
  userId?: number;
}

export interface IAppUserStats {
  lastLogin?: number;
  lastActivity?: number;
  lastBuildTime?: number;

  appVersion?: number;
  maxDevices?: number; // old
  deviceIds?: DeviceItem[]; // old
  multiDevice?: boolean; // old
  usedDeviceIds?: string[]; // old
}

export interface IAppUser extends IAppUserDealer, IAppUserStats {
  type: UserType
  _id: string;
  creationTime: number;
  markForDeletionTimestamp: number;
  //state: "active" | "blocked" | "deleted"; // todo
  isBlocked?: boolean;
  deviceId?: string | null;
  access: Access;
  accessFeatures?: AccessFeatures;
  pwdHashed: string;
  salt: string;
  pwdSentTimestamp?: number;
  contact?: IUserContactData;

  secretId: string;
}

export class AppUser {
  static isValidUserName(userName: string): boolean {
    return Util.isValidEmail(userName);
  }

  static isValidPassword(pwd: string): boolean {
    if (pwd?.length < 8)
      return false;
    return true;
  }

  static findUserResponsibilityFilter(appUser: IAppUser, filters: Record<string, IResponsibilityFilter>): IResponsibilityFilter | undefined {
    if (!appUser.responsibilityFilterId)
      return undefined;
    return filters[appUser.responsibilityFilterId];
  }

  static findObligatoryFilter(appUser: IAppUser, filters: Record<string, IResponsibilityFilter>, selectedFilterId?: string): IResponsibilityFilter | undefined {
    const userFilterId = AccessHelper.hasFeature(appUser, AccessFeature.IgnoreResponsibilityArea) ? undefined : appUser.responsibilityFilterId;
    if (userFilterId) {
      // if there is an obligatory user filter, use the user filter - otherwise the selected filter
      const foundFilter = filters[userFilterId]
      if (foundFilter)
        return foundFilter;
    }
    return selectedFilterId ? filters[selectedFilterId] : undefined;
  }
  static getDealerType(appUser: { access: Access; dealerType?: DealerType } | undefined): DealerType | undefined {
    if (!appUser)
      return undefined;
    if (appUser.access === Access.FluchtpunktAdmin) {
      return { ...appUser, ...AppUser.#getSuperAppUser() }.dealerType
    }
    return appUser?.dealerType;
  }
  static getAccess(appUser: IAppUser | undefined): Access {
    if (!appUser)
      return 0;
    if (appUser.access === Access.FluchtpunktAdmin) {
      // return Access.Dealer;
      return { ...appUser, ...AppUser.#getSuperAppUser() }.access || 0
    }
    return appUser.access || 0
  }
  static getType(appUser: IAppUser | undefined): IAppUser["type"] | undefined {
    if (!appUser)
      return undefined;
    if (appUser.access === Access.FluchtpunktAdmin) {
      return { ...appUser, ...AppUser.#getSuperAppUser() }.type
    }
    return appUser.type;
  }
  static #getSuperAppUser(): Partial<IAppUser> {
    if (isDebug()) {
      return {
        // access: Access.Dealer,
        // type: "private",
        // dealerType: undefined,
        dealerType: DealerType.RS,
        // dealerType: DealerType.RS,
        // dealerType: DealerType.SO,
      }
    } else {
      return {
        dealerType: DealerType.RS,
      }
    }
  }
  static getCompanyId(appUser: IAppUser): number;
  static getCompanyId(appUser: undefined): undefined;
  static getCompanyId(appUser: IAppUser | undefined): number | undefined;
  static getCompanyId(appUser: IAppUser | undefined): number | undefined {
    if (!appUser)
      return undefined;
    return appUser.companyId;
  }
}

export class BeosUser {
  static getCompanyId(beosUser: IBeosUser): number;
  static getCompanyId(beosUser: undefined): undefined;
  static getCompanyId(beosUser: IBeosUser | undefined): number | undefined;
  static getCompanyId(beosUser: IBeosUser | undefined): number | undefined {
    if (!beosUser)
      return undefined;
    return beosUser.companyId;
  }

  static calcContactFromBeosUser(beosUser: IBeosUser, beosCompany?: IBeosCompany): IUserContactData {
    const contact: IUserContactData = {
      firstName: beosUser.firstName,
      lastName: beosUser.lastName,
      sex: beosUser.gender,
      street: beosUser.address,
      city: beosUser.city,
      country: beosUser.country,
      phone: beosUser.phone,
    }

    if (beosCompany) {
      contact.company = [beosCompany.name1, beosCompany.name2, beosCompany.name3].filter((f) => !!f).join(" ");
      contact.www = beosCompany.www;
      contact.fax = beosCompany.fax;
      contact.uid = beosCompany.uid;
    }

    return contact;
  }
}